import { HexString } from 'shared/entities/color';

const isHexColor = (color: HexString): boolean => {
  return /^#[0-9A-Fa-f]{6}$/.test(color);
};

export default isHexColor;
